import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { hideModal, setModal } from "../../../redux/actions/modals";
import { deleteSchedule, setSelectedSchedule, updateSchedule } from "../../../redux/actions/schedules";
import { State } from "../../../redux/reducers/root";
import { Schedule } from "../../../redux/types";
import Toggle from "../form/toggle";
import { EDIT_SCHEDULE_MODAL } from "./constants";
import ModalTemplate from "./template";

interface Props {}

const EditScheduleModal: React.FC<Props> = () => {
  const modals = useSelector((state: State) => state.modals);
  const { schedule, doctorId } = modals.data as { schedule: Schedule; doctorId: string };
  const dispatch = useDispatch();
  const history = useHistory();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [isStatusChanging, setIsStatusChanging] = useState<boolean>(false);

  const onEdit = () => {
    dispatch(setSelectedSchedule(schedule));
    const path = `/doctors/${doctorId}/schedule/${schedule.id}?office=${schedule.officeId}`;
    history.push(path);
  };
  const onDelete = async () => {
    setIsDeleting(true);
    try {
      await dispatch(deleteSchedule(schedule.id, schedule.officeId));
      dispatch(hideModal());
    } finally {
      setIsDeleting(false);
    }
  };

  const changeStatus = async () => {
    setIsStatusChanging(true);
    try {
      const newschedule = { ...schedule, status: !schedule.status };
      await dispatch(updateSchedule(schedule.id, schedule.officeId, newschedule));
      dispatch(setModal({ modal: EDIT_SCHEDULE_MODAL, visible: true, data: { schedule: newschedule, doctorId } }));
    } finally {
      setIsStatusChanging(false);
    }
  };
  return (
    <ModalTemplate title="ویرایش برنامه" icon="fa fa-calendar-alt">
      <hr className="mt-3" />
      <div className="flex justify-between p-3" onClick={onEdit} id="scheduleEditBtn">
        ویرایش
        <i className="far fa-chevron-left" />
      </div>
      <hr />

      <div className="flex justify-between p-3" onClick={changeStatus}>
        <div>
          وضعیت:{" "}
          <span className={schedule.status ? "text-pkc-red" : "text-pkc-primary"}>
            {schedule.status ? "غیر فعال" : "فعال"}
          </span>
        </div>
        <Toggle value={!schedule.status} loading={isStatusChanging} />
      </div>
      <hr />
      <div className="flex justify-between p-3 text-pkc-red" onClick={onDelete} id="scheduleDeleteBtn">
        حذف کردن
        <i
          className={`flex justify-center items-center ${
            isDeleting ? "fa fa-spinner animate-spin" : "fa fa-chevron-left"
          }`}
        />
      </div>
    </ModalTemplate>
  );
};

export default EditScheduleModal;
